import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { DisplayError, ErrorState } from "../../../../core/api/errorTypes"

const initialState: ErrorState = {
    queue: [],
    current: undefined,
}

const errorSlice = createSlice({
    name: "error",
    initialState,
    reducers: {
        enqueueError: (state, action: PayloadAction<DisplayError>) => {
            state.queue.push(action.payload)
        },
        dequeueError: (state, _action: PayloadAction<void>) => {
            state.current = state.queue.shift()
        },
        removeCurrentError: (state, _action: PayloadAction<void>) => {
            state.current = undefined
        },
    },
})

export const { enqueueError, dequeueError, removeCurrentError } = errorSlice.actions
export const errorReducer = errorSlice.reducer
